import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { z } from 'zod'

export const useBridgeWebsocketPort = createLocalStorageHook(
  'websocket-port',
  z.number().int().gte(1).lte(65535)
)
